import request from '@/utils/request'

export const getTableData = params =>
  request.post('/workflow-api/credit-css/tnc/page', params)
// getHistoryData
export const getHistoryData = params =>
  request.post('/workflow-api/credit-css/tnc/pageHistory', params)
export const getTncDetail = id =>
  request.get(`/workflow-api/credit-css/tnc/detail/${id}`)
